import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router-dom'
import { useLocation } from 'react-router'
import { EnumSpinnerLoaderPosition, SpinnerLoader } from 'shared/ui'
import { BroadcastsRoutes } from 'entities/ExportRouters'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const BroadcastTableLayout = observer(() => {
  const { pathname } = useLocation()
  const { broadcastStore } = useEntitiesContext()

  useEffect(() => {
    broadcastStore.checkEmptyStateBroadcast(pathname.includes(BroadcastsRoutes.all))
  }, [])
  return (
    <>
      {broadcastStore.loadingEmptyState && (
        <SpinnerLoader
          ariaLabel={'BroadcastTableLayout'}
          position={EnumSpinnerLoaderPosition.Absolute}
        />
      )}
      <div
        style={{
          visibility: broadcastStore.loadingEmptyState ? 'hidden' : 'visible',
          height: '100%',
        }}
      >
        <Outlet />
      </div>
    </>
  )
})
